'use strict';

const StaticVersions = {
	sa: '1.22.2',
	quill: '1.3.7',
	swiper: '7.4.1',
	cropper: '1.5.12',
	mousetrap: '1.6.5',
	'aws-sdk': '2.1100.0',
	'spark-md5': '3.0.2',
	'jquery-ui/widgets/sortable': '1.13.0',
	'jquery-ui/widgets/mouse': '1.13.0',
	'jquery-ui/data': '1.13.0',
	'jquery-ui/ie': '1.13.0',
	'jquery-ui/scroll-parent': '1.13.0',
	'jquery-ui/version': '1.13.0',
	'jquery-ui/widget': '1.13.0',
	'jquery-form': '4.3.0',
	'vendor/jquery/draggable-background/backgroundDraggable': '1.2.4',
};

require.config({
	baseUrl: config.assetBaseUrl + '/src/modules',
	waitSeconds: 0,
	urlArgs: function (id, url) {
		// console.log(id, url);
		var args = 'v=';

		if (StaticVersions[id]) {
			args += StaticVersions[id];
		} else {
			args = config['cache-buster'];
		}

		return (url.indexOf('?') === -1 ? '?' : '&') + args;
	},
	paths: {
		forum: '../client',
		admin: '../admin',
		vendor: '../../vendor',
		plugins: '../../plugins',
	},
});
